import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import App from './scenes/App/App';
import {PersistGate} from 'redux-persist/integration/react';
import {persistor, store} from './store';


import './index.less';

ReactDOM.render(
   <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
          <Router basename={'/sign'}>
            <App />
         </Router>
      </PersistGate>
   </Provider>,
   document.getElementById('root'),
);
